import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import { blobErrorDetail, downloadBlob } from "../../lib/siteInfo";
import { LaunchCard, inputClass, inputStyle } from "./ui";

export function TransferExport() {
  const [data, setData] = useState(null);
  const [picked, setPicked] = useState([]);
  const [pass, setPass] = useState("");
  const [again, setAgain] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/transfer/sections").then(({ data: d }) => { setData(d); setPicked(d.sections.map((s) => s.key)); })
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);
  if (!data) return null;
  const toggle = (key) => setPicked(picked.includes(key) ? picked.filter((k) => k !== key) : [...picked, key]);
  const ok = picked.length && pass.length >= 12 && pass === again;
  const run = async () => {
    setBusy(true);
    try {
      await downloadBlob(api.post("/admin/transfer/export", { sections: picked, passphrase: pass }, { responseType: "blob" }), "employeesfirst-export.efx");
      toast.success("Export downloaded. Keep the passphrase separate from the file.");
    } catch (e) { toast.error(formatApiError(await blobErrorDetail(e))); }
    finally { setBusy(false); }
  };
  return (
    <LaunchCard eyebrow={`From ${data.environment}`} title="Export for production" testId="transfer-export-card">
      <p className="text-sm mb-4" style={{ color: "var(--muted)" }}>One encrypted file of the parts you tick. Passwords, sessions and release switches are never included.</p>
      <div className="grid gap-2 sm:grid-cols-2 mb-4">
        {data.sections.map((s) => (
          <label key={s.key} className="flex items-start gap-2 text-sm" style={{ color: "var(--ink)" }}>
            <input type="checkbox" className="mt-1" checked={picked.includes(s.key)} onChange={() => toggle(s.key)} data-testid={`transfer-export-section-${s.key}`} />
            <span>{s.label}<span className="block text-[11px]" style={{ color: "var(--muted)" }}>{s.records.toLocaleString()} records</span></span>
          </label>
        ))}
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div><label className="field-label">Passphrase (12+ characters)</label>
          <input type="password" className={inputClass} style={inputStyle} value={pass} onChange={(e) => setPass(e.target.value)} data-testid="transfer-export-passphrase" /></div>
        <div><label className="field-label">Repeat passphrase</label>
          <input type="password" className={inputClass} style={inputStyle} value={again} onChange={(e) => setAgain(e.target.value)} data-testid="transfer-export-passphrase-confirm" /></div>
      </div>
      <button type="button" className="btn-primary mt-4 flex items-center gap-2" disabled={!ok || busy} onClick={run} data-testid="transfer-export-btn">
        <Download size={14} /> {busy ? "Preparing…" : "Download export file"}
      </button>
    </LaunchCard>
  );
}
